import styled from "styled-components";
import MaterialInput from "../../../helperComponents/MaterialInput";
import CustomButton from "../../../helperComponents/CustomButton";
import { MdDelete } from "react-icons/md";
import { PiPlus } from "react-icons/pi";
import DropDownInput from "../../../helperComponents/DropDownInput";
import contractTypesForSite from "../../../../data/employee/contractTypesForSite";
import { useContext } from "react";
import Context from "../../../../Context";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* background: var(--surface3); */
  /* border: 1px solid var(--borderDim); */
  /* padding: 10px; */
  border-radius: 10px;
  gap: 30px;
  width: 100%;
  /* padding: 10px 15px; */
`;

const TopPart = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Label = styled.div`
  font-size: 17px;
  /* opacity: 0.5; */
  color: var(--elementDim);
  text-transform: capitalize;
`;

const ContractName = styled.div`
  font-size: 15px;
  /* opacity: 0.5; */
  font-weight: 600;
  color: var(--elementDim);
  text-transform: capitalize;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  position: relative;
`;

const SubRow = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100% - 80px);
  gap: 15px;
`;

const ItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default function ContractInputForSite({ value, onChange, label }) {
  const { employeeFunctions } = useContext(Context);
  const options = employeeFunctions?.length
    ? employeeFunctions
    : contractTypesForSite;

  if (!value) value = [];

  return (
    <Container>
      <TopPart>
        {/* <Label>{label}</Label> */}

        <DropDownInput
          label={label}
          options={options}
          onChange={addNewContract}
        />
      </TopPart>

      <List>
        {value.map((item, index) => {
          return (
            <ItemColumn>
              <ContractName>{getContractName(item.type)}</ContractName>

              <Row>
                <SubRow>
                  <MaterialInput
                    type="number"
                    label="Personnel de jour"
                    value={item.dayShift}
                    onChange={updateValue({ field: "dayShift", index })}
                  />

                  <MaterialInput
                    type="number"
                    label="Personnel de nuit"
                    value={item.nightShift}
                    onChange={updateValue({ field: "nightShift", index })}
                  />
                </SubRow>
                <CustomButton
                  style={{
                    width: "50px",
                    height: "55px",
                    flex: 1,
                    borderRadius: "10px",
                  }}
                  onClick={removeRow(index)}
                  icon={<MdDelete />}
                ></CustomButton>
              </Row>
            </ItemColumn>
          );
        })}
      </List>
    </Container>
  );

  function getContractName(type) {
    for (let item of options) {
      if (item.value == type) return item.label;
    }

    return "Aucun";
  }

  function addNewContract(newType) {
    let newValue = [...value];
    newValue.push({ type: newType, nightShift: 0, dayShift: 0 });
    onChange(newValue);
  }

  function removeRow(index) {
    return () => {
      // if (value.length <= 1) return null;

      let newValue = [...value];

      newValue.splice(index, 1);

      onChange(newValue);
    };
  }

  function updateValue({ field, index }) {
    return (e) => {
      let newValue = [...value];

      newValue[index][field] = e.target.value;

      onChange(newValue);
    };
  }
}
